/**
 * Quick Buy Quantity Button Handlers
 * Disables minus button when quantity is 1
 */
(function() {
  let inlineHandlersInitialized = false;

  function updateCartBubble(cart) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || !cart) return;

    const count =
      typeof window.getCartQuantityForHeaderBubble === 'function'
        ? window.getCartQuantityForHeaderBubble(cart)
        : cart.item_count || 0;
    let bubble = cartLink.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        cartLink.appendChild(bubble);
      }

      const countText = String(count);
      bubble.innerHTML = `
        <span aria-hidden="true">${countText}</span>
        <span class="visually-hidden">Cart (${count})</span>
      `;
    } else if (bubble) {
      bubble.remove();
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .catch(() => null);
  }

  function updateInlineQuantityStates() {
    const rows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
    rows.forEach((row) => {
      const qtyInput = row.querySelector('.qb-quantity-input');
      const minusBtn = row.querySelector('.qb-quantity-btn[data-action="decrement"]');
      if (!qtyInput || !minusBtn) return;

      const currentValue = parseInt(qtyInput.value, 10) || 1;
      if (currentValue <= 1) {
        minusBtn.disabled = true;
      } else {
        minusBtn.disabled = false;
      }
    });
  }

  function clampInlineQuantity(input) {
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const availableAttr = input.getAttribute('data-available-qty');
    const maxAttr = input.getAttribute('max');
    const max = availableAttr ? parseInt(availableAttr, 10) : maxAttr ? parseInt(maxAttr, 10) : null;
    let value = parseInt(input.value, 10);
    if (Number.isNaN(value)) value = min;
    if (value < min) value = min;
    if (max && value > max) value = max;
    input.value = String(value);
  }

  const QB_TOAST_CONTAINER_ID = 'qb-toast-container';
  const QB_TOAST_STYLE_ID = 'qb-add-to-cart-toast-style';

  function ensureAddToCartToastUi() {
    // Inject styles once per page.
    if (!document.getElementById(QB_TOAST_STYLE_ID)) {
      const style = document.createElement('style');
      style.id = QB_TOAST_STYLE_ID;
      style.textContent = `
        .qb-toast-container {
          position: fixed;
          top: 92px;
          right: 18px;
          z-index: 99999;
          display: flex;
          flex-direction: column;
          gap: 10px;
          pointer-events: none;
        }
        .qb-toast {
          pointer-events: auto;
          display: flex;
          align-items: flex-start;
          gap: 12px;
          min-width: 280px;
          max-width: min(420px, calc(100vw - 48px));
          background: #ffffff;
          border: 1px solid rgba(34, 197, 94, 0.35);
          border-radius: 14px;
          box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
          padding: 12px 12px;
          opacity: 0;
          transform: translateY(-6px);
          transition: opacity 180ms ease, transform 180ms ease;
        }
        .qb-toast--visible {
          opacity: 1;
          transform: translateY(0);
        }
        .qb-toast--hiding {
          opacity: 0;
          transform: translateY(-6px);
        }
        .qb-toast-icon {
          width: 36px;
          height: 36px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          background: rgba(34, 197, 94, 0.10);
          color: #16a34a;
          flex: 0 0 auto;
          margin-top: 2px;
        }
        .qb-toast-icon svg {
          width: 22px;
          height: 22px;
          display: block;
        }
        .qb-toast-content {
          flex: 1 1 auto;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 2px;
        }
        .qb-toast-title {
          font-size: 14px;
          font-weight: 700;
          color: #0f172a;
          line-height: 1.35;
          white-space: normal;
          word-wrap: break-word;
          overflow-wrap: anywhere;
        }
        .qb-toast-message {
          font-size: 13px;
          font-weight: 600;
          color: #16a34a;
          line-height: 1.4;
          white-space: normal;
          word-wrap: break-word;
          overflow-wrap: anywhere;
        }
        .qb-toast-close {
          pointer-events: auto;
          background: transparent;
          border: 0;
          padding: 6px;
          border-radius: 10px;
          color: rgba(15, 23, 42, 0.7);
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 auto;
        }
        .qb-toast-close:hover {
          background: rgba(15, 23, 42, 0.06);
        }
        .qb-toast-close svg {
          width: 18px;
          height: 18px;
          display: block;
        }
        @media (max-width: 480px) {
          .qb-toast-container { right: 12px; left: 12px; top: 84px; }
          .qb-toast { min-width: 0; width: 100%; }
        }
      `;
      document.head.appendChild(style);
    }

    // Create container once.
    let container = document.getElementById(QB_TOAST_CONTAINER_ID);
    if (!container) {
      container = document.createElement('div');
      container.id = QB_TOAST_CONTAINER_ID;
      container.className = 'qb-toast-container';
      container.setAttribute('aria-live', 'polite');
      container.setAttribute('aria-atomic', 'false');
      document.body.appendChild(container);
    }
  }

  function showAddToCartToast(productName, quantity) {
    ensureAddToCartToastUi();

    const container = document.getElementById(QB_TOAST_CONTAINER_ID);
    if (!container) return;

    const safeName = (productName && String(productName).trim()) ? String(productName).trim() : 'Product';
    const safeQty = Math.max(1, parseInt(quantity, 10) || 1);

    const toast = document.createElement('div');
    toast.className = 'qb-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = `
      <span class="qb-toast-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </span>
      <div class="qb-toast-content">
        <div class="qb-toast-title"></div>
        <div class="qb-toast-message"></div>
      </div>
      <button type="button" class="qb-toast-close" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    `;

    toast.querySelector('.qb-toast-title').textContent = safeName;
    toast.querySelector('.qb-toast-message').textContent = `added to cart (x${safeQty})`;

    function dismiss() {
      toast.classList.add('qb-toast--hiding');
      window.setTimeout(() => {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 200);
    }

    toast.querySelector('.qb-toast-close').addEventListener('click', dismiss);
    container.appendChild(toast);

    // Two rAFs so the initial style (opacity 0) is applied before transition.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => toast.classList.add('qb-toast--visible'));
    });

    window.setTimeout(dismiss, 3000);
  }

  /**
   * Stock Order: cart already holds the max available for this variant — same qb-toast UI as add-to-cart, informational copy only.
   */
  function showMaxAvailableInCartToast(productName) {
    ensureAddToCartToastUi();

    const container = document.getElementById(QB_TOAST_CONTAINER_ID);
    if (!container) return;

    const safeName = (productName && String(productName).trim()) ? String(productName).trim() : 'Product';

    const toast = document.createElement('div');
    toast.className = 'qb-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = `
      <span class="qb-toast-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </span>
      <div class="qb-toast-content">
        <div class="qb-toast-title"></div>
        <div class="qb-toast-message"></div>
      </div>
      <button type="button" class="qb-toast-close" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    `;

    toast.querySelector('.qb-toast-title').textContent = safeName;
    toast.querySelector('.qb-toast-message').textContent =
      'The maximum available quantity is already in your cart.';

    function dismiss() {
      toast.classList.add('qb-toast--hiding');
      window.setTimeout(() => {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 200);
    }

    toast.querySelector('.qb-toast-close').addEventListener('click', dismiss);
    container.appendChild(toast);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => toast.classList.add('qb-toast--visible'));
    });

    window.setTimeout(dismiss, 3000);
  }

  /**
   * Auto-added “Fees” line (e.g. under €500) is not on the Stock Order collection; show the same qb-toast when it appears.
   * Product admin ID: https://admin.shopify.com/.../products/10881214939403
   */
  const FEES_PRODUCT_ID = 10881214939403;
  let feesSnapshotHydrated = false;
  let lastFeesSnap = 'none';
  let feesCheckTimer = null;

  function processCartForFees(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    const line = cart.items.find((item) => Number(item.product_id) === FEES_PRODUCT_ID);
    const snap = line ? `${line.key}:${line.quantity}` : 'none';

    if (!feesSnapshotHydrated) {
      lastFeesSnap = snap;
      feesSnapshotHydrated = true;
      return;
    }
    if (snap === lastFeesSnap) return;

    const prev = lastFeesSnap;
    lastFeesSnap = snap;
    if (!line) return;

    const title = (line.product_title || line.title || 'Fees').trim();
    if (prev === 'none') {
      showAddToCartToast(title, line.quantity);
      return;
    }
    const prevParts = prev.split(':');
    const prevKey = prevParts[0];
    const prevQty = parseInt(prevParts[1], 10) || 0;
    if (prevKey !== line.key) {
      showAddToCartToast(title, line.quantity);
      return;
    }
    if (line.quantity > prevQty) {
      showAddToCartToast(title, line.quantity - prevQty);
    }
  }

  function scheduleFeesCartCheck() {
    if (feesCheckTimer) clearTimeout(feesCheckTimer);
    feesCheckTimer = setTimeout(() => {
      feesCheckTimer = null;
      fetchCart().then(processCartForFees);
    }, 100);
  }

  function installFeesCartListeners() {
    if (window.__qbFeesCartListenersInstalled) return;
    if (!document.querySelector('.qb-product-table')) return;
    window.__qbFeesCartListenersInstalled = true;

    fetchCart().then(processCartForFees);

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleFeesCartCheck());
    }

    const previousFetch = window.fetch.bind(window);
    window.fetch = function feesAwareFetch(...args) {
      const result = previousFetch.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url ? args[0].url : '';
        if (url && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url)) {
          result.then(() => scheduleFeesCartCheck()).catch(() => {});
        }
      } catch (e) {
        /* noop */
      }
      return result;
    };
  }

  function initInlineHandlers() {
    if (inlineHandlersInitialized) return;
    inlineHandlersInitialized = true;

    document.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('.qb-quantity-btn');
      if (qtyBtn) {
        e.preventDefault();
        const wrapper = qtyBtn.closest('.qb-quantity-selector');
        const input = wrapper ? wrapper.querySelector('.qb-quantity-input') : null;
        if (!input || input.disabled) return;

        const action = qtyBtn.getAttribute('data-action');
        const step = action === 'increment' ? 1 : -1;
        input.value = String((parseInt(input.value, 10) || 1) + step);
        clampInlineQuantity(input);
        updateInlineQuantityStates();
        return;
      }

      const addBtn = e.target.closest('.qb-add-to-cart-btn');
      if (addBtn) {
        e.preventDefault();
        handleInlineAddToCart(addBtn);
      }
    });

    document.addEventListener('input', (e) => {
      const input = e.target.closest('.qb-quantity-input');
      if (!input) return;
      clampInlineQuantity(input);
      updateInlineQuantityStates();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      // CHANGE: Improved detection - check if target is input itself or find via closest
      const input = e.target.classList && e.target.classList.contains('qb-quantity-input') 
        ? e.target 
        : e.target.closest('.qb-quantity-input');
      if (!input || input.disabled) return;
      e.preventDefault();
      e.stopPropagation(); // Prevent form submission or other handlers
      const row = input.closest('tr.qb-row');
      const addBtn = row ? row.querySelector('.qb-add-to-cart-btn') : null;
      if (addBtn && !addBtn.disabled) {
        handleInlineAddToCart(addBtn);
      }
    });
  }

  /**
   * Stockorder Add-to-Cart: ADDITIVE semantics.
   * Adds selectedQty on top of existing cart quantity for this variant (never sets line to selector value).
   * CHANGE: Stock-limit validation added to prevent exceeding available quantity.
   */
  function handleInlineAddToCart(button) {
    if (!button || button.disabled) return;

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    const row = button.closest('tr.qb-row');
    const qtyInput = row ? row.querySelector('.qb-quantity-input') : null;
    const availableAttr = qtyInput ? qtyInput.getAttribute('data-available-qty') : (row ? row.getAttribute('data-available-qty') : null);
    const availableQty = availableAttr !== null && availableAttr !== '' ? parseInt(availableAttr, 10) : null;
    const rawSelectedQty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
    const selectedQty = Math.max(1, rawSelectedQty);
    const productName = row ? (row.querySelector('.qb-product-name')?.textContent || '') : '';

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = window.fetchConfig ? fetchConfig('javascript') : { method: 'POST', headers: { 'Accept': 'application/json' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const finalizeUpdate = (cartData) => {
      if (cartData) {
        // Always sync bubble: cart-notification renderContents injects section HTML with raw item_count (includes fee line).
        updateCartBubble(cartData);
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'quick-buy',
            productVariantId: variantId,
            cartData: cartData || null,
          });
        }
        // Always show toast, even when the same product is added again.
        showAddToCartToast(productName, selectedQty);
      }
    };

    const proceedAdd = (quantityToAdd) => {
      if (!quantityToAdd || quantityToAdd <= 0) return;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantityToAdd);

      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }

      config.body = formData;
      button.disabled = true;

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'quick-buy',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            fetchCart().then(finalizeUpdate);
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof cart.renderContents === 'function') cart.renderContents(response);
          fetchCart().then(finalizeUpdate);
        })
        .catch(() => {})
        .finally(() => { button.disabled = false; });
    };

    const proceedChange = (lineItemKey, targetQty) => {
      if (!lineItemKey || targetQty < 0) return;

      const formData = new FormData();
      formData.append('id', lineItemKey);
      formData.append('quantity', targetQty);

      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }

      config.body = formData;
      button.disabled = true;

      fetch('/cart/change.js', config)
        .then((response) => response.json())
        .then((cartData) => {
          finalizeUpdate(cartData);
        })
        .catch(() => {})
        .finally(() => { button.disabled = false; });
    };

    fetchCart()
      .then((cartData) => {
        // CHANGE: Handle null cartData gracefully - treat as empty cart
        if (!cartData || !Array.isArray(cartData.items)) {
          // If cart fetch failed, proceed with add (assume item not in cart)
          const qtyToAdd = availableQty !== null && !Number.isNaN(availableQty) && availableQty > 0
            ? Math.min(selectedQty, availableQty) 
            : selectedQty;
          if (qtyToAdd <= 0) {
            button.disabled = false;
            return;
          }
          proceedAdd(qtyToAdd);
          return;
        }

        const cartItem = cartData.items.find((item) => String(item.id) === String(variantId)) || null;
        const existingQty = cartItem ? cartItem.quantity : 0;
        let targetQty = existingQty + selectedQty;

        // CHANGE: Stock-limit validation - clamp targetQty to availableQty if limit exists
        if (availableQty !== null && !Number.isNaN(availableQty) && availableQty > 0) {
          if (targetQty > availableQty) {
            targetQty = availableQty;
          }
          // If already at or above limit, don't proceed — only inform (no cart change).
          if (existingQty >= availableQty) {
            showMaxAvailableInCartToast(productName);
            button.disabled = false;
            return;
          }
        }

        if (!cartItem) {
          // CHANGE: For new items, ensure we don't add more than available
          const qtyToAdd = availableQty !== null && !Number.isNaN(availableQty) && availableQty > 0
            ? Math.min(selectedQty, availableQty) 
            : selectedQty;
          if (qtyToAdd <= 0) {
            button.disabled = false;
            return;
          }
          proceedAdd(qtyToAdd);
          return;
        }
        proceedChange(cartItem.key, targetQty);
      })
      .catch((error) => {
        // CHANGE: On error, fallback to direct add (assume item not in cart)
        const qtyToAdd = availableQty !== null && !Number.isNaN(availableQty) && availableQty > 0
          ? Math.min(selectedQty, availableQty) 
          : selectedQty;
        if (qtyToAdd > 0) {
          proceedAdd(qtyToAdd);
        } else {
          button.disabled = false;
        }
      });
  }

  function initQuantityButtonStates() {
    setTimeout(() => {
      const rows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
      if (rows.length > 0) updateInlineQuantityStates();
    }, 300);
    let attempts = 0;
    const checkInterval = setInterval(() => {
      const rows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
      if (rows.length > 0) {
        clearInterval(checkInterval);
        updateInlineQuantityStates();
      }
      attempts++;
      if (attempts > 30) clearInterval(checkInterval);
    }, 200);
  }

  const observer = new MutationObserver(() => {
    setTimeout(updateInlineQuantityStates, 100);
  });
  
  const targetNode = document.getElementById('QuickBuySearchList');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }
  
  // Initialize immediately and also on DOMContentLoaded
  initQuantityButtonStates();
  initInlineHandlers();
  installFeesCartListeners();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantityButtonStates);
  }
})();

